var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden go_win_obj",style:(_vm.extendStyle),attrs:{"id":_vm.winIdStr}},[_c('div',{staticClass:"toast-ctl toast-top-right",staticStyle:{"position":"absolute"},style:(_vm.getMaxZIndex),attrs:{"id":_vm.msgIdStr,"aria-live":"polite","role":"alert"}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/go-win.vue